let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4nSjz")).then(() => parcelRequire('1FaqS'));